import { render, staticRenderFns } from "./MissingPunch.vue?vue&type=template&id=3f041906&"
import script from "./MissingPunch.vue?vue&type=script&lang=js&"
export * from "./MissingPunch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports